import React from "react";
import BreadcrumpTemp from "../Template/BreadcrumpTemp";

// Import your Defence product images
import prod1 from "../../img/defence/3 inch FPV.webp";
import prod2 from "../../img/defence/5 inch FPV.jpg";
import prod3 from "../../img/defence/8 inch FPV.jpg";
import prod4 from "../../img/defence/10 inch FPV.jpg";
import prod5 from "../../img/defence/13 inch FPV.jpg";
import prod6 from "../../img/defence/15 inch FPV.jpg";
import prod7 from "../../img/defence/50kg Logistics Drone.jpg";
import prod8 from "../../img/defence/NainaV1.jpg";
import prod9 from "../../img/defence/NainaV2.jpg";

import "../../style/articleEvent.css";

export default function DefenceProducts() {
  const breadProp = {
    title: "Defence Products",
    text: "This page will showcase all Defence related products.",
    arr: ["Home", "Defence Products"],
  };

  const products = [
    { img: prod1, text: "3 Inch FPV Drone" },
    { img: prod2, text: "5 Inch FPV Drone" },
    { img: prod3, text: "8 Inch FPV Drone" },
    { img: prod4, text: "10 Inch FPV Drone" },
    { img: prod5, text: "13 Inch FPV Drone" },
    { img: prod6, text: "15 Inch FPV Drone" },
    { img: prod7, text: "50kg Logistics Drone" },
    { img: prod8, text: "NainaV1 Drone" },
    { img: prod9, text: "NainaV2 Drone" },
  ];

  return (
    <div>
      <BreadcrumpTemp bprops={breadProp} />

      <h1 style={{ textAlign: "center", marginTop: "20px" }}>
        Defence Products
      </h1>

      <p
        style={{
          textAlign: "center",
          marginTop: "10px",
          maxWidth: "1000px",
          marginLeft: "auto",
          marginRight: "auto",
          lineHeight: "1.8",
        }}
      >
        Our defence product lineup is engineered to empower armed forces, law
        enforcement, and security professionals with cutting-edge technology.
        From innovative drones to specialized defence tools, we provide
        solutions that ensure mission success in the most challenging
        environments.
      </p>

      <div className="art-div-cnt">
        <div className="event-lists">
          {products.map((product, index) => (
            <div key={index} className="event-card-t">
              <div
                className="event-card"
                style={{ cursor: "default" }}
              >
                <img src={product.img} alt={product.text} />
                <p>{product.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}